<template>
  <div class="about">
    <div class="about-inner">
      <h1>Daily Report</h1>
      <p>
        하루를 2시간 간격으로 나누어<br>12개의 아이템으로 관리합니다.<br>각 시간에 했던 일과<br>몰입도를 점수로 표현합니다.
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'About',
  components: {

  },
  props: [

  ],
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {

  },
  created() {

  },
  watch: {

  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/About.vue